import React from 'react';

const BazaarCurrentItemInteractionToolsSkeleton = () => (
    <div className="bazaar_current-item_interaction-tools_skeleton">
        <div className="bazaar_current-item_interaction-tools_skeleton_btn-group">
            <div className="bazaar_current-item_interaction-tools_skeleton_btn-group_head">
                <div className="bazaar_current-item_interaction-tools_skeleton_btn-group_head_tabs">
                    <button className="skeleton"></button>
                    <button className="skeleton"></button>
                </div>
            </div>
            <div className="bazaar_current-item_interaction-tools_skeleton_btn-group_tabs-content_buy">
                <span className="skeleton"></span>
                <div className="bazaar_current-item_interaction-tools_skeleton_btn-group_tabs-content_buy_price skeleton"/>
                <div className="bazaar_current-item_interaction-tools_skeleton_btn-group_tabs-content_buy_btns">
                    <button className="skeleton"></button>
                    <button className="skeleton"></button>
                </div>
            </div>
            <div className="bazaar_current-item_interaction-tools_skeleton_btn-group_accordion skeleton"></div>
        </div>
    </div>
)

export default BazaarCurrentItemInteractionToolsSkeleton